<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
  <g>
    <path d="M58.23,126.88A11,11,0,0,0,60,138.6L141.84,231a11.27,11.27,0,0,0,16.32,0L240,138.6a10.91,10.91,0,0,0-8.16-18.15H182.73V21.91A10.9,10.9,0,0,0,171.82,11H128.18a10.9,10.9,0,0,0-10.91,10.91v98.54H68.18a10.92,10.92,0,0,0-10,6.43Z"/>
    <path d="M0,272.64A16.37,16.37,0,0,0,16.36,289H283.64a16.36,16.36,0,0,0,0-32.72H16.36A16.37,16.37,0,0,0,0,272.64Z"/>
  </g>
</svg>
